import { render, staticRenderFns } from "./PendingOrders.vue?vue&type=template&id=462e1928&scoped=true&"
import script from "./PendingOrders.vue?vue&type=script&lang=ts&"
export * from "./PendingOrders.vue?vue&type=script&lang=ts&"
import style0 from "./PendingOrders.vue?vue&type=style&index=0&id=462e1928&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462e1928",
  null
  
)

export default component.exports